// extracted by mini-css-extract-plugin
export var dividerLine = "_5z-3";
export var itemImage = "_5z-9";
export var lightDivider = "_5z-4";
export var modalContent = "_5z-5";
export var modalContentCompact = "_5z-6";
export var productCard = "_5z-a";
export var productImage = "_5z-b";
export var productImageCompact = "_5z-7";
export var productImagePlaceholder = "_5z-c";
export var productImagePlaceholderCompact = "_5z-8";
export var progressBarBackground = "_5z-1";
export var progressBarContainer = "_5z-0";
export var progressBarFill = "_5z-2";